module.exports = __webpack_public_path__ + "static/media/hal_btm_4.296447fe.png";